const WINDOWS_RESERVED_NAME =
  /^(?:CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])(?:\..*)?$/i;

export const sanitizeFilenameComponent = (value, fallback = "document") => {
  let component = String(value ?? "").trim();

  component = Array.from(component, (character) => {
    const codePoint = character.codePointAt(0);
    const isControl = codePoint <= 0x1f || codePoint === 0x7f;
    const isLineSeparator = codePoint === 0x2028 || codePoint === 0x2029;

    return isControl || isLineSeparator || /[<>:"/\\|?*]/.test(character)
      ? "-"
      : character;
  })
    .join("")
    .replace(/-+/g, "-")
    .replace(/^[.\s]+|[.\s]+$/g, "");

  if (!component || component === "." || component === "..") {
    component = String(fallback);
  }

  if (WINDOWS_RESERVED_NAME.test(component)) {
    component += "_";
  }

  return component.slice(0, 180).replace(/[.\s]+$/g, "") || String(fallback);
};

export const pdfDownloadFilename = (prefix, email, id) =>
  `${prefix}-${sanitizeFilenameComponent(email, id)}.pdf`;

const padTimestampPart = (value) => String(value).padStart(2, "0");

export const zipDownloadFilename = (
  prefix,
  { all = false, date = new Date() } = {},
) => {
  const timestamp =
    [
      date.getFullYear(),
      padTimestampPart(date.getMonth() + 1),
      padTimestampPart(date.getDate()),
    ].join("") +
    `-${padTimestampPart(date.getHours())}${padTimestampPart(date.getMinutes())}`;

  return `${prefix}${all ? "_All" : ""}-${timestamp}.zip`;
};
